// extracted by mini-css-extract-plugin
export var pillTrigger = "_5k-0";